import { makeAsyncAction } from '../../../ui-lottery';
import * as types from '../constants/actions';
import * as api from '../api';
import { CurrentUserDefaults } from '../props/currentUser';
import SecurityHelper from '../utils/security';

export const login = makeAsyncAction(types.LOGIN, (params) => () => api.login(params));

export const reload = makeAsyncAction(types.RELOAD, (data) => () => Promise.resolve({ data }));

export const logout = makeAsyncAction(types.LOGOUT, () => () => {
  SecurityHelper.clearData();
  return Promise.resolve({ data: CurrentUserDefaults });
});

export const updateCurrentUser = makeAsyncAction(types.UPDATE_CURRENT_USER,
  (userData) => () => Promise.resolve({ data: userData })
);
